import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { MemberSubscriptionsApi } from '@deckee/api-app-main';
import { AppAsyncThunkAPI } from '../..';
import { checkClientToken } from '../../../backend';
import {
  selectCurrentMemberId,
  selectHasCurrentMemberActiveSubscription,
} from '../backend-service';
import apiConfiguration from '../../../backend/apiConfiguration';

const api = new MemberSubscriptionsApi(apiConfiguration);

export const setIsLoading = createAction(
  '[Subscriptions] Loading subscription details',
  (isLoading: boolean) => ({ payload: isLoading }),
);

export const showSubscriptionSuccess = createAction(
  '[Subscriptions] show subscription success',
  (subscriptionSuccess = true) => ({
    payload: subscriptionSuccess,
  }),
);

export const setPortalUrl = createAction(
  '[Subscriptions] Set subscription portal Url',
  (portalUrl = true) => ({
    payload: portalUrl,
  }),
);

export const fetchMemberSubscribed = createAsyncThunk<
  boolean,
  void,
  AppAsyncThunkAPI
>('[Subscriptions] fetch member subscribed', async (_, { getState }) => {
  await checkClientToken();
  return selectHasCurrentMemberActiveSubscription(getState()) || false;
});

export const fetchMemberSubscriptionPortalUrl = createAsyncThunk<void, void>(
  '[Subscriptions] fetch subscription portal url for the member',
  async (_, { dispatch, rejectWithValue, getState, signal }) => {
    dispatch(setIsLoading(true));

    const memberId = selectCurrentMemberId(getState());
    if (!memberId) {
      rejectWithValue('No current member');
    } else {
      signal.throwIfAborted();
      try {
        const {
          data: { url },
        } = await api.getMemberSubscriptionPortal();

        dispatch(setPortalUrl(url));
      } catch (e: any) {
        if (!signal.aborted) {
          dispatch(setIsLoading(false));
          throw rejectWithValue(e.message);
        }
      }
      dispatch(setIsLoading(false));
    }
  },
);
